import LogRocket from 'logrocket';
const version  = require('./../../package.json').version

const initLogRocket = function initLogRocket(userData) {
    // console.log("INIT LOGROCKET", userData, process.env.NODE_ENV)
   if(process.env.NODE_ENV == 'production') {
    LogRocket.init(process.env.VUE_APP_LOG_ROCKET_ID);
    if(userData) {
      LogRocket.identify(userData.userId, {
        name: userData.userName,
        version:version,
        email: userData.userName,
        // Add your own custom user variables here, ie:
        companyID: userData.companyId,
        company: userData.companyId
      });
    }
  }
};


export default initLogRocket;